// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__ecVfJ","withValue":"style__withValue__50Q7L"};